module.exports = __webpack_public_path__ + "img/trade.a92c9ed6.svg";